/**
 * Compare two Copilot versions ("2.10.0" against "2.9.3"): 1 when a is newer,
 * -1 when b is, 0 when equal or either cannot be read.
 *
 * Its own file since fastphone-4: the update check runs once for the whole
 * app and needs only this, not the licence module it used to live in.
 */
export function compareVersions(a?: string | null, b?: string | null): number {
    const pa = (a ?? '').split('.').map(Number), pb = (b ?? '').split('.').map(Number);
    if (pa.some(Number.isNaN) || pb.some(Number.isNaN) || !a || !b) return 0;
    for (let i = 0; i < 3; i++) { const d = (pa[i] ?? 0) - (pb[i] ?? 0); if (d) return d > 0 ? 1 : -1; }
    return 0;
}
